
import type { DeclarationData, HistoryEntry } from './types';

export const mockExtractedData: DeclarationData = {
  exporter: {
    name: "Global Trade Solutions Ltd",
    tin: "TIN123456789",
    address: "123 Export Street, Sydney, Australia"
  },
  importer: {
    name: "Pacific Import Co.",
    tin: "TIN987654321",
    address: "456 Import Road, Port Moresby, Papua New Guinea"
  },
  items: [
    {
      itemNo: 1,
      description: "Industrial Machinery Parts",
      commodityCode: "8479.89.00",
      originCountry: "AU",
      grossMass: 500,
      netMass: 450,
      quantity: 50,
      unitPrice: 1250.00,
      totalValue: 62500.00,
      hsCode: "8479890000",
      classificationRationale: "Classified as other machines and mechanical appliances having individual functions, not specified or included elsewhere in Chapter 84.",
      dutyRate: "Free",
      primaryLaw: "Customs Tariff Act 2022, Part III",
      legalMethodology: {
        gir: ["1", "6"],
        partIIIClause: "8(1)",
        explanatoryNotes: ["EN 84.79"],
        rulingsConsidered: []
      }
    },
    {
      itemNo: 2,
      description: "Electronic Components",
      commodityCode: "8542.31.00",
      originCountry: "AU",
      grossMass: 150,
      netMass: 120,
      quantity: 200,
      unitPrice: 45.00,
      totalValue: 9000.00,
      hsCode: "8542310000",
      classificationRationale: "Electronic integrated circuits; Processors and controllers.",
      dutyRate: "Free",
      primaryLaw: "Customs Tariff Act 2022, Part III",
      legalMethodology: {
        gir: ["1", "6"],
        partIIIClause: "8(1)",
        explanatoryNotes: ["EN 85.42"],
        rulingsConsidered: []
      }
    }
  ],
  shipping: {
    billOfLading: "BOL2025001234",
    vesselName: "MV Pacific Star",
    arrivalDate: "2025-02-15",
    portOfDischarge: "Port Moresby",
    incoterms: "CIF"
  },
  financial: {
    totalInvoiceAmount: 71500.00,
    currency: "USD",
    exchangeRate: 3.75,
    totalPGK: 268125.00
  }
};

export const mockHistory: HistoryEntry[] = [
  { id: 1, date: '2025-02-06', reference: 'DEC-2025-001', status: 'completed', importer: 'Pacific Import Co.' },
  { id: 2, date: '2025-02-05', reference: 'DEC-2025-002', status: 'completed', importer: 'Island Traders Ltd' },
  { id: 3, date: '2025-02-04', reference: 'DEC-2025-003', status: 'completed', importer: 'PNG Industries' }
];
